import React, { useEffect, useState } from "react";

let _setProgress = null;
let _timer = null;
let _current = 0;

export function startLoading() {
  if (_setProgress) {
    _current = 0;
    _setProgress(5);
    _timer = setInterval(() => {
      _current = Math.min(_current + Math.random() * 8, 88);
      _setProgress(_current);
    }, 180);
  }
}

export function stopLoading() {
  if (_timer) { clearInterval(_timer); _timer = null; }
  if (_setProgress) {
    _setProgress(100);
    setTimeout(() => _setProgress(0), 400);
  }
}

export default function GlobalLoadingBar() {
  const [progress, setProgress] = useState(0);
  useEffect(() => { _setProgress = setProgress; return () => { _setProgress = null; }; }, []);

  if (progress === 0) return null;

  return (
    <div
      className="fixed top-0 left-0 z-[9999] h-[2px] transition-all"
      style={{
        width: `${progress}%`,
        background: 'linear-gradient(90deg, var(--gold) 0%, #E8C080 50%, var(--gold) 100%)',
        backgroundSize: '200% 100%',
        animation: progress < 100 ? 'shimmer 1.2s ease-in-out infinite' : undefined,
        opacity: progress === 100 ? 0 : 1,
        transition: progress === 100 ? 'opacity 300ms ease 100ms, width 200ms ease' : 'width 180ms ease',
        boxShadow: '0 0 8px rgba(183,149,91,0.6)',
      }}
      aria-hidden="true"
    />
  );
}
